import { IconFiles } from '@tabler/icons';
import { dashboard } from './dashboard';
import { adminMenu } from './users';
import { buildProjectMenu } from './project';
import { buildDemoMenu } from './demo';
import { isDemoUser } from '../utils/demoAccess';

const adminBaseMenu = {
    items: [adminMenu, dashboard],
};

const defaultBaseMenu = {
    items: [dashboard],
};

// Demo-only top-level nav item, shown right under Dashboard (same style as All Files).
const rmDocumentsItem = {
    id: 'demo_rm_documents',
    title: 'RM Documents',
    type: 'item',
    url: '/demo/rm-documents',
    icon: IconFiles,
    breadcrumbs: false,
};

// Returns a copy of the dashboard group for demo accounts: Dashboard is labelled "Supplier
// Outreach", with the RM Documents item appended under it.
const forDemo = (grp) => ({
    ...grp,
    children: [
        ...grp.children.map((c) => (c.id === 'default' ? { ...c, title: 'Supplier Outreach' } : c)),
        rmDocumentsItem,
    ],
});

export const buildMenu = ({ role, projects = [], email } = {}) => {
    const demo = isDemoUser(email);
    const base = role === 'admin' ? adminBaseMenu : defaultBaseMenu;
    const baseItems = demo
        ? base.items.map((grp) => (grp.id === 'dashboard' ? forDemo(grp) : grp))
        : base.items;
    const projectGroups = projects.map((p) =>
        buildProjectMenu(p.id, p.name, p.onDismiss, { filesLabel: demo ? 'Project Files' : 'All Files' })
    );
    const demoGroups = demo ? [buildDemoMenu()] : [];
    return {
        items: [...baseItems, ...demoGroups, ...projectGroups],
    };
};

// Legacy exports kept for any imports that still use the old constants.
export const adminMenuItems = adminBaseMenu;
export const defaultMenuItems = defaultBaseMenu;
